import { useState, useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import { exportToExcel } from "../helpers";
import { downloadInactiveCeaStart, resetInactiveCeaState } from "../redux/reducers/drmInactiveCeaSlice";

const INACTIVE_DOWNLOAD_PAGE_SIZE = 1000;

const EMPTY_INACTIVE_FILTERS = {
  carrierSCAC: [],
  originZone: [],
  destinationZone: [],
  tariffId: [],
  serviceCode: [],
  dailyMinLoad: { params: [], operator: "" },
  dailyMaxLoad: { params: [], operator: "" },
  weeklyMinLoad: { params: [], operator: "" },
  weeklyMaxLoad: { params: [], operator: "" },
  equipmentCode: [],
  bucketType: [],
};

export const useInactiveCeaDownload = (fromDate, toDate) => {
  const dispatch = useDispatch();

  const {
    isDownloading,
    downloadedRows,
    successMessage,
    downloadError,
  } = useSelector((state) => state.drmInactiveCea);

  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });

  const hasDates = Boolean(fromDate && toDate);

  const handleDownload = useCallback(() => {
    if (!hasDates) return;

    const formattedFrom = dayjs(fromDate).format("MM/DD/YYYY");
    const formattedTo = dayjs(toDate).format("MM/DD/YYYY");

    dispatch(resetInactiveCeaState());
    dispatch(
      downloadInactiveCeaStart({
        filters: {
          fromDate: { date: [formattedFrom], operator: ">=" },
          toDate: { date: [formattedTo], operator: "<=" },
          ...EMPTY_INACTIVE_FILTERS,
        },
        pageSize: INACTIVE_DOWNLOAD_PAGE_SIZE,
      })
    );
  }, [hasDates, fromDate, toDate, dispatch]);

  useEffect(() => {
    if (successMessage && downloadedRows.length > 0) {
      exportToExcel(downloadedRows, "InactiveLaneConstraints");
      setSnackbar({ open: true, message: successMessage, severity: "success" });
      dispatch(resetInactiveCeaState());
    }
  }, [successMessage, downloadedRows, dispatch]);

  // Show download errors
  useEffect(() => {
    if (downloadError) {
      setSnackbar({ open: true, message: downloadError, severity: "error" });
      dispatch(resetInactiveCeaState());
    }
  }, [downloadError, dispatch]);

  const handleSnackbarClose = useCallback(() => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  }, []);

  return {
    handleDownload,
    hasDates,
    isDownloading,
    snackbar,
    handleSnackbarClose,
  };
};
